import { Chart } from "./chart.js"
import { CheckBox } from "./checkbox.js"
import { Axes } from "./core/elements/axes.js"
import { ChartImage } from "./core/elements/chart-image.js"
import { Font } from "./core/elements/font.js"
import { Format } from "./core/elements/format.js"
import { Gradient } from "./core/elements/gradient.js"
import { Legend, LegendSymbol } from "./core/elements/legend.js"
import { Margins } from "./core/elements/margins.js"
import { Panel } from "./core/elements/panel.js"
import { Scroll } from "./core/elements/scroll.js"
import { Shadow } from "./core/elements/shadow.js"
import { Stroke } from "./core/elements/stroke.js"
import { Wall } from "./core/elements/wall.js"
import { Zoom } from "./core/elements/zoom.js"
import { Point, Rectangle } from "./core/primitives.js"
import { TeeData } from "./data/index.js"
import { doHttpRequest } from "./do-http-request.js"
import { DOMTip } from "./dom-tip.js"
import { drawSpline, Scroller, SliderControl } from "./extras.js"
import { AfricaMap, AsiaMap, AustraliaMap, Europe27Map, EuropeMap, SouthAmericaMap, USAMap, WorldMap } from "./maps/geo-maps.js"
import { LayoutMap } from "./maps/layout-map.js"
import { SVGMap } from "./maps/svg-map.js"
import { MarksAnimation } from "./marks-animation.js"
import { Palette, RainbowPalette } from "./palette.js"
import { ActivityGauge, Area, Bar, Bubble, Bullet, Candle, ColorGrid, CustomBar, CustomSeries, Donut, Gantt, HighLowBar, HorizArea, HorizBar, Line, Map, PaletteSeries, Pie, PointXY, Polar, Series, SeriesList, Sliced, Surface, Treemap, Volume } from "./series.js"
import { CircularGauge } from "./series/circular-gauge.js"
import { LinearGauge } from "./series/linear-gauge.js"
import { NumericGauge } from "./series/numeric-gauge.js"
import { Slider } from "./slider.js"
import { Table } from "./table/table.js"
import { MyParametricGeometry, Three } from "./teechart-3d.js"
import { applyPalette, applyTheme } from "./theme.js"
import { AnimateHover, Animation, Annotation, CursorTool, DragTool, FadeAnimation, Marks, SeriesAnimation, Title, Tool, ToolTip } from "./tools/index.js"

export let Tee = {};

Tee.Point = Point
Tee.Rectangle = Rectangle
Tee.Margins = Margins

Tee.Tool = Tool
Tee.Animation = Animation

Tee.Annotation = Annotation
Tee.AnimateHover = AnimateHover

Tee.Gradient = Gradient
Tee.Shadow = Shadow
Tee.ChartImage = ChartImage
Tee.Stroke = Stroke
Tee.Font = Font
Tee.Format = Format

Tee.DragTool = DragTool
Tee.CursorTool = CursorTool
Tee.ToolTip = ToolTip

Tee.RainbowPalette = RainbowPalette
Tee.Palette = Palette

Tee.Zoom = Zoom
Tee.Scroll = Scroll

Tee.Title = Title

Tee.Panel = Panel
Tee.Wall = Wall

Tee.LegendSymbol = LegendSymbol
Tee.Legend = Legend
Tee.Marks = Marks

if (!("map" in Array.prototype)) {
	Array.prototype.map = function (mapper, that /*opt*/) {
		var other = new Array(this.length)
		for (var i = 0, n = this.length; i < n; i++) if (i in this) other[i] = mapper.call(that, this[i], i, this)

		return other
	}
}
if (!("filter" in Array.prototype)) {
	Array.prototype.filter = function (filter, that /*opt*/) {
		var other = [],
			v
		for (var i = 0, n = this.length; i < n; i++)
			if (i in this && filter.call(that, (v = this[i]), i, this)) other.push(v)

		return other
	}
}

Tee.Series = Series
Tee.SeriesList = SeriesList
Tee.Axes = Axes

Tee.Chart = Chart

Tee.CustomBar = CustomBar
Tee.Bar = Bar
Tee.HorizBar = HorizBar
Tee.Bullet = Bullet
Tee.CustomSeries = CustomSeries
Tee.Line = Line
Tee.PointXY = PointXY
Tee.Pie = Pie
Tee.Area = Area
Tee.HighLowBar = HighLowBar
Tee.HorizArea = HorizArea
Tee.Donut = Donut
Tee.ActivityGauge = ActivityGauge
Tee.Gantt = Gantt
Tee.Bubble = Bubble
Tee.Volume = Volume
Tee.Candle = Candle
Tee.Polar = Polar

// String.trim:
if (typeof String.prototype.trim !== "function") {
	String.prototype.trim = function () {
		return this.replace(/^\s+|\s+$/g, "")
	}
}

Tee.PaletteSeries = PaletteSeries

Tee.DOMTip = DOMTip

Tee.drawSpline = drawSpline

Tee.Chart.prototype.applyTheme = applyTheme
Tee.Chart.prototype.applyPalette = applyPalette

Tee.doHttpRequest = doHttpRequest

Tee.Slider = Slider
Tee.Scroller = Scroller
Tee.SliderControl = SliderControl
Tee.CheckBox = CheckBox

if (typeof exports !== "undefined") exports.Tee = Tee

Tee.FadeAnimation = FadeAnimation
Tee.SeriesAnimation = SeriesAnimation
Tee.MarksAnimation = MarksAnimation

Tee.Sliced = Sliced
Tee.Treemap = Treemap

// ---------------------------------------------------------
// -------------------- GAUGES --------------------
// ---------------------------------------------------------

Tee.LinearGauge = LinearGauge
Tee.CircularGauge = CircularGauge
Tee.NumericGauge = NumericGauge

// ---------------------------------------------------------
// --------------------- TEECHART MAPS ---------------------
// ---------------------------------------------------------

Tee.SVGMap = SVGMap
Tee.LayoutMap = LayoutMap
Tee.AfricaMap = AfricaMap
Tee.AsiaMap = AsiaMap
Tee.AustraliaMap = AustraliaMap
Tee.Europe27Map = Europe27Map
Tee.EuropeMap = EuropeMap
Tee.SouthAmericaMap = SouthAmericaMap
Tee.WorldMap = WorldMap
Tee.USAMap = USAMap
Tee.Map = Map

// --------------------------------------------------------
// ------------------- TEECHART DATA ----------------------
// --------------------------------------------------------

Tee.Data = TeeData

// --------------------------------------------------------
// ------------------- TEECHART TABLE ---------------------
// --------------------------------------------------------

Tee.Table = Table

// TEECHART 3D

Tee.ColorGrid = ColorGrid
Tee.Surface = Surface

// Three.JS
Tee.MyParametricGeometry = MyParametricGeometry
Tee.Three = Three
